<template>
    <Head v-if="enquiry!=null" :title="enquiry.id" />


    <el-container fluid v-if="enquiry!=null">
        <el-header>
            <el-menu

                class="el-menu-demo"
                mode="horizontal"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b"
                :ellipsis="false"
            >
                <el-menu-item class="grey-bn" @click="goBack">
                    <i class="fa-solid fa-arrow-left"></i> Back
                </el-menu-item>
                <el-menu-item >TRIP ID - {{enquiry.id}}</el-menu-item>

                <el-menu-item class="fwww">

                </el-menu-item>
                <el-menu-item class="grey-bn menu-hit-item menu-icon-btn" @click="openNewTicket">
                    <new-ticket ref="newTicketRef" :enquiryid="enquiry.id"></new-ticket>
                </el-menu-item>
                <el-menu-item class="grey-bn menu-hit-item menu-icon-btn" v-if="enquiry.permissions.settings">
                    <el-dropdown class="menu-fill-dropdown" trigger="click" @click.stop>
                        <span class="menu-fill-hit">
                            <i class="fa-solid fa-gear"></i>
                        </span>
                        <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item>
                                Low Profit -  <el-switch v-model="enquiry.allowlowprofit" :active-value="1"
                                                         :inactive-value="0" style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"  @change="settinglowprofit()"/>

                            </el-dropdown-item>


                        </el-dropdown-menu>
                    </template>
                    </el-dropdown>
                </el-menu-item>
                <el-menu-item  class="red-bn" v-if="enquiry.related.length>0" @click="showdupes=true" >
                    Dupe Enquiry
                </el-menu-item>
                <el-menu-item  class="white-bn" v-if="enquiry.is_hot==1 && enquiry.status!='Converted'" >
                    <img style="height: 20px;" src="/images/hot.png"/> &nbsp;Hot Lead
                </el-menu-item>
                <el-menu-item class="lead-score-menu-item" v-if="enquiry.lead_score !== null && enquiry.lead_score !== undefined">
                    <lead-score-badge
                        :score="enquiry.lead_score"
                        :type="enquiry.lead_score_type"
                        :label="enquiry.lead_score_label"
                    />
                </el-menu-item>



                <el-menu-item  v-bind:class="{ 'warning-bn': enquiry.status=='Pending' ,'red-bn':enquiry.status=='Closed','success-bn':enquiry.status=='Converted','info-bn':enquiry.status=='InProgress'}" >
                    {{enquiry.status}}
                </el-menu-item>
                <el-menu-item class="grey-bn menu-hit-item menu-text-btn" v-if="enquiry.status!='Converted'" @click="openEnquiryAction">
                    <enquiry-action ref="enquiryActionRef" :istext="true"  :enquiry="enquiry"  :languages="languages" :user="authuser" @actionevent="getdetails"></enquiry-action>

                </el-menu-item>

                <el-menu-item v-bind:class="{ 'warning-bn': enquiry.bookingdetails.stage=='Postponed' ,'red-bn':enquiry.bookingdetails.stage=='Cancelled','success-bn':enquiry.bookingdetails.stage=='Booked'}"  v-if="enquiry.status=='Converted'" @click="editbookingstage()">
                    {{enquiry.bookingdetails.stage}}
                </el-menu-item>

                <el-menu-item class="info-bn" v-if="enquiry.status=='Converted'" @click="openTripFulfilment">
                    Operations
                </el-menu-item>

                <el-menu-item class="grey-bn" v-if="enquiry.status=='Converted'">
                    <el-dropdown>
                        Generate                         <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item>
                                    <a :href="'/enquiry/vouchers/hotelvoucher?enqid='+enquiry.encryptedid" >
                                        Hotel Voucher
                                    </a>

                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <a :href="'/enquiry/vouchers/flightvoucher?enqid='+enquiry.encryptedid" >
                                        Flight Voucher
                                    </a>

                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <a :href="'/enquiry/vouchers/landvoucher?enqid='+enquiry.encryptedid" >
                                        Land Voucher
                                    </a>

                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <a :href="'/enquiry/vouchers/receiptvoucher?enqid='+enquiry.encryptedid">
                                        Receipt Voucher
                                    </a>

                                </el-dropdown-item>

                                <el-dropdown-item v-if="enquiry.permissions.generate.invoice">
                                    <a :href="'/enquiry/generate/invoice?enqid='+enquiry.encryptedid">
                                        Invoice
                                    </a>

                                </el-dropdown-item>
                                <el-dropdown-item v-if="enquiry.permissions.generate.invoice && enquiry.is_flight">
                                    <a :href="'/enquiry/generate/flightinvoice?enqid='+enquiry.encryptedid">
                                        Flight Invoice
                                    </a>

                                </el-dropdown-item>
                                <el-dropdown-item v-if="enquiry.permissions.generate.invoice">
                                    <a :href="'/booking/print?enqid='+enquiry.encryptedid">
                                        Print
                                    </a>

                                </el-dropdown-item>

                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </el-menu-item>




            </el-menu>
        </el-header>
        <el-main>
            <el-row :gutter="20">
                <el-col class="pr-w100" :span="6">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <TravellerDetails @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>
                        <el-col class="mt-2" :span="24">
                            <EnquiryAssign  @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>

                        <el-col class="mt-2 noprint" :span="24">
                            <EnquiryCallAttempts  @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>

                        <el-col class="mt-2 noprint" :span="24">
                            <EnquiryRelationshipStrength  @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>

                        <el-col class="mt-2 noprint" :span="24">
                            <EnquiryNextStep  @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>

                        <el-col class="mt-2 noprint" :span="24" v-if="enquiry.status=='Converted'">
                            <EnquiryHandover  @saved="getdetails()" :enquiry="enquiry" :authuser="authuser"/>
                        </el-col>

                        <el-col class="mt-2 noprint" :span="24">
                            <EnquiryLogs  @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>
                    </el-row>

                </el-col>
                <el-col class="pr-w100" :span="18">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <TravellerRequirement @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>
                        <el-col class="mt-2" :span="24" v-if="enquiry.status=='Converted'">
                            <PaxDetails @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>
                        <el-col class="mt-2" :span="24" v-if="enquiry.status=='Converted'">
                            <QuotationPricingDetails @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>
                        <el-col class="mt-2" :span="24" v-if="enquiry.status=='Converted'">
                            <FinalPricingDetails @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>
                        <el-col class="mt-2 noprint" :span="24" v-if="enquiry.status=='Converted'">
                            <BookingDocuments @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>
                        <el-col class="mt-2" :span="24" v-if="enquiry.status=='Converted'">
                            <CustomerPayments @saved="getdetails()" :enquiry="enquiry" :authuser="authuser"/>
                        </el-col>
                        <el-col class="mt-2" :span="24" v-if="enquiry.status=='Converted' && enquiry.permissions.vendorpayments.view">
                            <VendorPayments @saved="getdetails()" :enquiry="enquiry" :authuser="authuser"/>
                        </el-col>
                        <el-col class="mt-2 noprint" :span="24" v-if="enquiry.status=='Converted' && enquiry.permissions.servicesmanage.view && (enquiry.is_hotel || enquiry.listservices.hotels.length>0)">
                            <HotelServices @saved="getdetails()" :enquiry="enquiry" :authuser="authuser"/>
                        </el-col>




                        <el-col class="mt-2 noprint" :span="24">
                            <EnquiryQuotataions @saved="getdetails()" :enquiry="enquiry" />
                        </el-col>





                    </el-row>
                </el-col>

            </el-row>
        </el-main>
    </el-container>



    <el-drawer v-model="showdupes" direction="rtl" >
        <template #header>
            <h4>Duplicate Enquiries</h4>
        </template>
        <template #default>
            <el-card class="mt-1 enqdetcard" v-for="related in enquiry.related" @click="viewenquiry(related.encryptedid)">
                CDM{{related.id}}

                <el-tag :type="related.status=='Closed' ? 'danger' : 'primary'">{{related.status}}</el-tag>


            </el-card>
        </template>

    </el-drawer>

    <el-drawer v-model="editbookingstagemodel" direction="rtl" >
        <template #header>
            <h4>Booking Stage</h4>
        </template>
        <template #default>
            <el-form
                label-position="top"
                ref="ruleFormRef"
                :model="tempform.bookingstage"
                status-icon
                :rules="rules.bookingstage"

            >

                <el-form-item label="Booking Stage"  prop="stage">
                    <el-select v-model="tempform.bookingstage.stage" style="width: 100%"  placeholder="Select" size="large">
                        <el-option
                            label="Booked"
                            value="Booked"
                        />
                        <el-option
                            label="Postponed"
                            value="Postponed"
                        />
                        <el-option
                            label="Cancelled"
                            value="Cancelled"
                        />
                    </el-select>
                </el-form-item>

            </el-form>
        </template>
        <template #footer >
            <div style="flex: auto" >

                <el-button  type="primary" @click="savebookingstage()"  :loading="loading" :disabled="loading">Save</el-button>




            </div>
        </template>
    </el-drawer>




</template>

<script>
import PaxDetails from './Enquiry/Components/PaxDetails'
import TravellerDetails from './Enquiry/Components/TravellerDetails'
import TravellerRequirement from './Enquiry/Components/TravellerRequirement'
import EnquiryLogs from './Enquiry/Components/EnquiryLogs'
import EnquiryAssign from './Enquiry/Components/EnquiryAssign'
import EnquiryCallAttempts from './Enquiry/Components/EnquiryCallAttempts'
import EnquiryRelationshipStrength from './Enquiry/Components/EnquiryRelationshipStrength'
import EnquiryNextStep from './Enquiry/Components/EnquiryNextStep'
import EnquiryQuotataions from './Enquiry/Components/EnquiryQuotataions'
import QuotationPricingDetails from './Enquiry/Components/QuotationPricingDetails'
import FinalPricingDetails from './Enquiry/Components/FinalPricingDetails'
import BookingDocuments from './Enquiry/Components/BookingDocuments'
import CustomerPayments from './Enquiry/Components/CustomerPayments'
import VendorPayments from './Enquiry/Components/VendorPayments'
import HotelServices from './Enquiry/Components/HotelServices'
import EnquiryHandover from './Enquiry/Components/EnquiryHandover'
import LeadScoreBadge from './Enquiry/Components/LeadScoreBadge.vue'

import {
    ElLoading,ElRow,ElCol,ElDropdown,ElDropdownMenu,ElDropdownItem,ElFormItem,ElSelect,ElOption,ElMenu,ElMenuItem,ElSubMenu,ElContainer,ElHeader,ElMain,ElTag,ElButton,ElDrawer,ElCard,ElForm
} from 'element-plus'
import $ from 'jquery';
import moment from 'moment';
export default {
    name: "ViewEnquiry",
    props:['id','userdepart'],
    components: {
        LeadScoreBadge,PaxDetails,EnquiryHandover,HotelServices,VendorPayments,CustomerPayments,BookingDocuments,FinalPricingDetails,QuotationPricingDetails,EnquiryQuotataions,EnquiryAssign,EnquiryCallAttempts,EnquiryRelationshipStrength,EnquiryNextStep,EnquiryLogs,TravellerDetails,TravellerRequirement,ElRow,ElCol,ElDropdown,ElDropdownMenu,ElDropdownItem,ElFormItem,ElSelect,ElOption,ElMenu,ElMenuItem,ElSubMenu,ElContainer,ElHeader,ElMain,ElTag,ElButton,ElDrawer,ElCard,ElForm
    },
        data() {
        return {
            backUrl: '/enquiry',
            editbookingstagemodel:false,
            showdupes:false,
            loading:false,
            enquiry:null,
            authuser:null,
            tempform:{
                bookingstage:{
                  stage :''
                },
           },
            rules:{
                bookingstage:{
                    stage: [{ required: true, trigger: 'change', message:'Required' }],
                }
            },

        }
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        const returnParam = params.get('return');
        if (returnParam && returnParam.startsWith('/')) {
            this.backUrl = returnParam;
        }
        this.getdetails();
    },
    created() {



    },
    methods: {
        openNewTicket() {
            if (this.$refs.newTicketRef && this.$refs.newTicketRef.open) {
                this.$refs.newTicketRef.open();
            }
        },
        openEnquiryAction() {
            if (this.$refs.enquiryActionRef && this.$refs.enquiryActionRef.open) {
                this.$refs.enquiryActionRef.open();
            }
        },
        settinglowprofit(){
            let currentObj = this;
            currentObj.loading=true;
            axios.post('/enquiry/setting?id='+this.id,{'allowlowprofit':this.enquiry.allowlowprofit}).then(function (response) {


                toastr.success('Setting Changed Succesfully.');
                currentObj.loading=false;
                currentObj.getdetails();
            })
                .catch(function (error) {
                    currentObj.loading=false;
                    toastr.error('Something Wrong try again.');
                });
        },
        editbookingstage(){
            this.editbookingstagemodel=true;
            this.tempform.bookingstage.stage=this.enquiry.bookingdetails.stage;

        },
        openTripFulfilment(){
            if (this.enquiry && this.enquiry.id) {
                window.open('/operations/trips/' + this.enquiry.id, '_blank');
            }
        },
        savebookingstage(){

            let currentObj = this;
            currentObj.loading=true;
            axios.post('/savebookingstage?id='+this.id,this.tempform.bookingstage).then(function (response) {


                toastr.success('Changed Succesfully.');
                currentObj.loading=false;
                currentObj.editbookingstagemodel=false;
                currentObj.getdetails();
            })
                .catch(function (error) {
                    currentObj.loading=false;
                    toastr.error('Something Wrong try again.');
                });
        },
        goBack() {
            window.location.href = this.backUrl;
        },
        viewenquiry(id){
            const returnUrl = encodeURIComponent(this.backUrl);
            window.open('/viewenquiry?id=' + id + '&return=' + returnUrl, '_blank');
        },
        getdetails() {

            const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })

            let currentObj = this;
            axios.get('/enquirydetails?id='+this.id).then(function (response) {
                currentObj.enquiry=response.data.enquiry;
                currentObj.authuser=response.data.user;
                loading.close();
                currentObj.notifyEnquiryViewed(currentObj.enquiry.id);
            })
                .catch(function (error) {
                    loading.close();
                });
        },

        notifyEnquiryViewed(enquiryId) {
            try {
                const channel = new BroadcastChannel('bon-travel-crm-enquiry-updated');
                channel.postMessage({ enquiryId });
                channel.close();
            } catch (e) {
                // BroadcastChannel not supported in older browsers.
            }
        },



    }
}
</script>

<style scoped>
.lead-score-menu-item {
    cursor: default !important;
}
.lead-score-menu-item:hover,
.lead-score-menu-item:focus {
    background-color: transparent !important;
}
</style>
